import { render, staticRenderFns } from "./materialChangeRecodList.vue?vue&type=template&id=ba4397d8"
import script from "./materialChangeRecodList.vue?vue&type=script&lang=js"
export * from "./materialChangeRecodList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports